import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { FrontServicesPageComponent } from './pages/front-services-page/front-services-page.component';
import { FrontPagesComponent } from './front-pages.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';

const routes: Routes = [
  {
    path: 'services',
    component:ComingSoonComponent
  },
  {
    path: '',
    component: FrontPagesComponent,

  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: FrontPagesComponent },
  {
    path: 'coming-soon',
    component: ComingSoonComponent,

  },
  {
    path: 'support-and-assistance',
    component: ComingSoonComponent,

  },
  {
    path: 'sbout-single-window',
    component: ComingSoonComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class FrontPagesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/front-pages/front-pages-routing.module.ts